module.exports = __webpack_public_path__ + "static/media/complotGlass.66e0c088.jpg";